import { render, staticRenderFns } from "./Pendant.vue?vue&type=template&id=186cf8b2&scoped=true&"
import script from "./Pendant.vue?vue&type=script&lang=js&"
export * from "./Pendant.vue?vue&type=script&lang=js&"
import style0 from "./Pendant.vue?vue&type=style&index=0&id=186cf8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186cf8b2",
  null
  
)

export default component.exports